var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnapprovedleaverules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2V5H7.11111C5.4 5 4 6.35 4 8V29C4 30.65 5.4 32 7.11111 32H28.8889C30.6 32 32 30.65 32 29V8C32 6.35 30.6 5 28.8889 5H27.3333V2H24.2222V5H11.7778V2H8.66667ZM7.11111 8H8.66667H11.7778H24.2222H27.3333H28.8889V11H7.11111V8ZM7.11111 14H28.8889V29H7.11111V14Z",
    fill: "#3C3D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6083 21.7583C22.6667 21.4666 22.6667 21.2333 22.6667 21C22.6667 20.7666 22.6667 20.5333 22.6083 20.2416L23.7167 19.25L22.375 16.9166L20.975 17.3833C20.5667 17.0916 20.1583 16.8 19.6917 16.625L19.3417 15.1666H16.6583L16.3667 16.625C15.8417 16.8 15.4333 17.0916 15.025 17.3833L13.625 16.9166L12.2833 19.25L13.3917 20.2416C13.3333 20.5333 13.3333 20.7666 13.3333 21C13.3333 21.2333 13.3333 21.4666 13.3917 21.7583L12.2833 22.75L13.625 25.0833L15.025 24.6166C15.4333 24.9083 15.8417 25.2 16.3083 25.375L16.6583 26.8333H19.4L19.6917 25.375C20.1583 25.2 20.625 24.9666 20.975 24.6166L22.375 25.0833L23.7167 22.75L22.6083 21.7583ZM18 23.3333C16.7167 23.3333 15.6667 22.2833 15.6667 21C15.6667 19.7166 16.7167 18.6666 18 18.6666C19.2833 18.6666 20.3333 19.7166 20.3333 21C20.3333 22.2833 19.2833 23.3333 18 23.3333Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnapprovedleaverules);
export default __webpack_public_path__ + "static/media/unapprovedleaverules.543a94bd4f7359335e9af8f8fb1156b1.svg";
export { ForwardRef as ReactComponent };